export default {
  LOCALE: "en_GB"
};
